import { render, staticRenderFns } from "./discardAdmin.vue?vue&type=template&id=134f2561&"
import script from "./discardAdmin.vue?vue&type=script&lang=js&"
export * from "./discardAdmin.vue?vue&type=script&lang=js&"
import style0 from "./discardAdmin.vue?vue&type=style&index=0&id=134f2561&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports